module.exports = __webpack_public_path__ + "static/media/imagem39.1b0567e5.jpeg";